import React from "react";
import { Dialog, DialogContent, IconButton, Stack, useMediaQuery, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarehouseItemForm from "./WarehouseItemForm";

export default function WarehouseItemFormDialog({
  open,
  onClose,
  categories,
  suppliers,
  initialValues,
  onSubmit,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 4 } }}
      data-testid="warehouse.items.form-dialog"
    >
      <Stack direction="row" justifyContent="flex-end" sx={{ p: 1 }}>
        <IconButton
          onClick={onClose}
          size="small"
          data-testid="warehouse.items.form-dialog.close-button"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>
      <DialogContent
        sx={{
          p: { xs: 2.5, sm: 3.5 },
          pt: 0,
          bgcolor: (theme) =>
            theme.palette.mode === "light" ? "grey.50" : "rgba(255,255,255,0.02)",
        }}
      >
        <WarehouseItemForm
          categories={categories}
          suppliers={suppliers}
          initialValues={initialValues}
          onSubmit={onSubmit}
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  );
}